// ConfirmCutModal.js — Cut confirmation modal extracted from WeeklyLineupManager
import React from 'react';
import { AlertTriangle, Crown, Zap } from 'lucide-react';
import { weeklyLineupUtils } from '../../utils/weeklyLineupUtils';
import CenteredModal from '../sheets/CenteredModal';

const ConfirmCutModal = ({
  showConfirmCut,
  setShowConfirmCut,
  confirmCut,
  isSaving,
  captain,
  tripPlayTeam,
}) => {
  const isOpen = !!showConfirmCut;
  if (!isOpen) return null;

  const { team } = showConfirmCut;
  const gamePoints = team.currentSeason?.gamePoints || 0;
  const record = team.currentSeason?.record || '0-0';
  const normalizedTeamName = weeklyLineupUtils.normalizeTeamName(team);
  const isCaptain = captain === normalizedTeamName;
  const isTripPlay = tripPlayTeam === normalizedTeamName;

  return (
    <CenteredModal
      open={isOpen}
      onClose={() => setShowConfirmCut(null)}
      icon={AlertTriangle}
      iconTone="danger"
      title={`Cut ${team.school}?`}
      primaryLabel="Cut team"
      primaryLoading={isSaving}
      primaryLoadingLabel="Cutting…"
      onPrimary={confirmCut}
      primaryTone="danger"
      secondaryLabel="Cancel"
      onSecondary={() => setShowConfirmCut(null)}
    >
      <div className="rounded-lg p-3 text-left mt-1" style={{ backgroundColor: 'var(--color-bg-page)' }}>
        <div className="font-medium" style={{ color: 'var(--color-text-strong)' }}>{team.school}</div>
        <div className="text-sm" style={{ color: 'var(--color-text-muted)' }}>{team.conference}</div>
        <div className="text-sm mt-1" style={{ color: 'var(--color-text-muted)' }}>{gamePoints} season points, {record}</div>
        {isCaptain && (
          <div className="text-sm mt-1.5 font-semibold flex items-center gap-1.5" style={{ color: 'var(--color-captain-deep)' }}>
            <Crown size={13} /> This is your current captain
          </div>
        )}
        {isTripPlay && (
          <div className="text-sm mt-1.5 font-semibold flex items-center gap-1.5" style={{ color: 'var(--color-tripplay)' }}>
            <Zap size={13} /> This team has your 5x Play active
          </div>
        )}
      </div>
    </CenteredModal>
  );
};

export default ConfirmCutModal;
